import { IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IAuthEmailBody,
  IAuthEmailRequestBody,
  IAuthEmailVerifyBody,
  IAuthenticationMetadataResponse,
  IAuthPhonePinBody,
  IAuthPhoneRequestBody,
  IAuthPhoneVerifyBody,
  IAuthTestCredentialsBody,
  IAuthTokenPostBody,
  IAuthUsernameBody,
  IResetPasswordConfirmBody,
  IResetPasswordRequestBody,
  IUserOnlyTokenResponse,
  IUserOrgTokenResponse,
} from '../types'

export class AuthResource {
  constructor(private readonly agent: IHttpAgent) {}

  public async requestPasswordReset(body: IResetPasswordRequestBody): Promise<void> {
    await this.agent.post('auth/email/reset/request', body)
  }

  public async verifyPasswordReset(body: IResetPasswordConfirmBody): Promise<void> {
    await this.agent.post('/auth/email/reset/verify', body)
  }

  public async emailLogin(body: IAuthEmailBody): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('auth2/email/login', body)
    return res.data
  }

  public async driverLogin(body: IAuthEmailBody | IAuthUsernameBody): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('/auth/driver/login', body)
    return res.data
  }

  public async testCredentialsLogin(body: IAuthTestCredentialsBody): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('auth/rider/test/login', body)
    return res.data
  }

  public async phoneLoginRequest(body: IAuthPhoneRequestBody): Promise<void> {
    await this.agent.post('/auth/rider/phone/request', body)
  }

  public async phoneLoginVerify(body: IAuthPhoneVerifyBody): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('/auth/rider/phone/verify', body)
    return res.data
  }

  public async emailLoginRequest(body: IAuthEmailRequestBody): Promise<void> {
    await this.agent.post('/auth/rider/email/request', body)
  }

  public async emailLoginVerify(body: IAuthEmailVerifyBody): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('/auth/rider/email/verify', body)
    return res.data
  }

  public async buildOrganizationToken(body: IAuthTokenPostBody): Promise<IUserOrgTokenResponse> {
    const res = await this.agent.post<IUserOrgTokenResponse>('auth/token', body)
    return res.data
  }

  public async buildSuperAdminToken(): Promise<IUserOnlyTokenResponse> {
    const res = await this.agent.post<IUserOnlyTokenResponse>('auth/token/superAdmin')
    return res.data
  }

  public async getMetadata(): Promise<IAuthenticationMetadataResponse> {
    const { data } = await this.agent.get<IAuthenticationMetadataResponse>('auth/metadata')
    return data
  }

  public async buildOrganizationTokenFromPhonePin(body: IAuthPhonePinBody): Promise<IUserOrgTokenResponse> {
    const { data } = await this.agent.post<IUserOrgTokenResponse>('auth/rider/phonePin', body)
    return data
  }

  public async riderPinLogin(body: IAuthPhonePinBody): Promise<IUserOnlyTokenResponse> {
    const { data } = await this.agent.post<IUserOnlyTokenResponse>('auth/rider/pin/login', body)
    return data
  }
}
